import request from '@/api/request.js'

// 新增
export function SystemIPAddressInsert(data) {
    return request({
        url: '/api/ipaddress/systemipaddressinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function SystemIPAddressDelete(id) {
    return request({
        url: `/api/ipaddress/systemipaddressdelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function SystemIPAddressUpdate(id, data) {
    return request({
        url: `/api/ipaddress/systemipaddressupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function SystemIPAddressGetById(id) {
    return request({
        url: `/api/ipaddress/getsystemipaddressbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取
export function SystemIPAddressGetByName(data) {
    return request({
        url: '/api/ipaddress/getsystemipaddresslist',
        method: 'post',
        data: data
    })
}

// 获取列表
export function SystemIPAddressGetList(params) {
    return request({
        url: '/api/ipaddress/getsystemipaddresslist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function SystemIPAddressGetPageList(params) {
    return request({
        url: '/api/ipaddress/getsystemipaddresspagelist',
        method: 'get',
        params: params
    })
}